export const FIELD_REQUIRED = "Заполните это поле"
export const EMAIL_OR_PHONE_REQUIRED = "Заполните одно из полей: E-mail или Телефон"
export const EMAIL_NOT_VALID = "E-mail должен быть действительным"
export const PHONE_NOT_VALID = "Телефон должен быть действительным"
export const VALIDATION_FAILED = "Проверьте правильность заполнения данных"
export const PHONE_REGEX = /^(\+?\d{0,4})?\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{3}\)?)\s?-?\s?(\(?\d{4}\)?)?$/
export const SEARCH_PLACEHOLDER = "Я ищу..."